<template>
  <!--  导航菜单-->
  <div id="new-home-nav">
    <div class="new-home-nav-box">
      <div class="nav-item" v-for="(item,index) in param.data" :key="index" @click="goNextPage(item)">
        <div class="nav-item-sec">
          <!--            <router-link to='/goodClassify'>-->
          <img :src="item.icon" alt="" />
          <div class="item-name">{{item.name}}</div>
          <!--            </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navIcon",
  props:['param'],
  methods: {
    goNextPage(item){
      console.log(item)
      var url = item.uri
      let urlPage = url.split('https')
      // console.log(urlPage)
      if (urlPage.length==2){
        // console.log(item.uri)
        window.open(item.uri)
        // window.open('https://kuailong.itos.cn/Wechat/Index/index.html?state=0dfc590eedcfb742c6ef1ac247259760cb886062')
      } else {
        // console.log(1111)
        this.$router.push({path: url,query:{name:item.name}})
      }
    },
  }
}
</script>

<style lang="scss" scoped>
#new-home-nav {
  margin-top: 230px;
  .new-home-nav-box{
    flex-wrap: wrap;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-bottom: 10px;
    .nav-item{
      width: 20%;font-size: 26px;
      .nav-item-sec{
        margin: 20px;text-align: center;
        img{
          width: 100%;height: auto;display: block;margin-bottom: 10px;
        }
        .item-name{color: #333333;}
      }
    }
  }
}
</style>
